<era-pane>
  <h5 class="small-caps"
      i18n>Lost Mode</h5>
  @if (!isSupported) {
    <p>
      <small class="form-text text-muted"
             [hidden]="isSupervised()">Availabe when device is supervised.</small>
      <small class="form-text text-muted"
             [hidden]="hasSupportedOS()">Available in iOS 9.3 and later.</small>
    </p>
  } @else {
    <div class="row justify-content-between">
      @if (!isLostModeEnabled()) {
        <ml-mdm-enable-lost-mode [apple]="apple()"
                                 class="col-12"></ml-mdm-enable-lost-mode>
      } @else {
        <ml-mdm-disable-lost-mode [class]="'btn btn-primary'"
                                  [apple]="apple()"
                                  class="col-6">
          Disable lost mode</ml-mdm-disable-lost-mode>
      }
      @if (isLostModeEnabled() && (apple() | os: { iOS: '>=10.3' })) {
        <ml-mdm-play-lost-mode-sound [class]="'btn btn-primary'"
                                     [apple]="apple()"
                                     class="col-6 text-end">
          <fa-icon [icon]="['far', 'bell']"></fa-icon>
          <span>Play lost mode sound</span>
        </ml-mdm-play-lost-mode-sound>
      }
    </div>
  }
</era-pane>